import { useCallback, useEffect, useState } from 'react';
import { AcceptTermsAPI, GetTermsAPI } from 'api';
import useStore from 'store/AccountStore';
import { normalizeTermsContent } from './termsAcceptance.constants';

function useTermsAcceptance({ enabled }) {
  const updateUser = useStore((state) => state.updateUser);
  const [termsContent, setTermsContent] = useState(null);
  const [isLoadingTerms, setIsLoadingTerms] = useState(false);
  const [isAccepting, setIsAccepting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (!enabled) {
      setTermsContent(null);
      setIsLoadingTerms(false);
      setErrorMessage('');
      return;
    }

    setIsLoadingTerms(true);
    setTermsContent(null);
    setErrorMessage('');

    GetTermsAPI({
      onSuccess: (data) => {
        const normalized = normalizeTermsContent(data);
        if (!data?.id || !normalized) {
          setTermsContent(null);
          setErrorMessage('Unable to load terms. Please try again.');
          return;
        }
        setTermsContent(data);
      },
      onError: () => {
        setTermsContent(null);
        setErrorMessage('Unable to load terms. Please try again.');
      },
      callBack: () => {
        setIsLoadingTerms(false);
      },
    });
  }, [enabled]);

  const acceptTerms = useCallback(() => {
    if (!termsContent?.id) {
      setErrorMessage('Unable to save terms acceptance. Please try again.');
      return;
    }

    setIsAccepting(true);
    setErrorMessage('');
    AcceptTermsAPI({
      requestBody: { id: termsContent.id },
      onSuccess: () => {
        updateUser({ termsAccepted: true });
      },
      onError: () => {
        setErrorMessage(
          'Unable to save terms acceptance. Please try again.',
        );
      },
      callBack: () => {
        setIsAccepting(false);
      },
    });
  }, [termsContent, updateUser]);

  return {
    termsContent,
    isLoadingTerms,
    isAccepting,
    errorMessage,
    acceptTerms,
  };
}

export default useTermsAcceptance;
